function ErrorPage() {
  return (
    <div style={{marginTop:"100px"}}>ErrorPage</div>
  )
}

export default ErrorPage